import { render, staticRenderFns } from "./ParticipantsEditCard.vue?vue&type=template&id=4dd006a7&scoped=true"
import script from "./ParticipantsEditCard.vue?vue&type=script&lang=js"
export * from "./ParticipantsEditCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsEditCard.vue?vue&type=style&index=0&id=4dd006a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd006a7",
  null
  
)

export default component.exports